import { BuzzlUser, BuzzlUserDTO } from '../types/buzzl-user'
import { Customer } from '../types/customer'
import { PartialPick } from '../types/type-helper'
import { buzzlRoles } from '../utils/config'
import { graphQLClient } from './authService'
import buzzlUserMutations from './graphql/buzzlUsers/mutations'

const parseAssignedUsers = (ids: string[]) => ids.map((id) => ({ id }))

class BuzzlUsersService {
  createBuzzlUser = async ({
    customers,
    firstName,
    lastName,
    // displayName,
    email,
    role,
  }: BuzzlUserDTO): Promise<BuzzlUser> => {
    const assignedCustomers: PartialPick<Customer, 'id'>[] = customers.length > 0 ? parseAssignedUsers(customers) : []

    const { createBuzzlUser: response } = await graphQLClient.request<{
      createBuzzlUser: BuzzlUser
    }>(buzzlUserMutations.createBuzzlUser, {
      data: {
        user: { createOrConnect: { email } },
        firstName,
        lastName,
        assignedCustomers: role === buzzlRoles.operator ? { connect: assignedCustomers } : undefined,
        role,
      },
    })

    return response
  }

  deleteBuzzlUser = async (id: string): Promise<{ count: number }> => {
    const { deleteBuzzlUsers: response } = await graphQLClient.request<{
      deleteBuzzlUsers: { count: number }
    }>(buzzlUserMutations.deleteBuzzlUser, {
      where: {
        id_in: id,
      },
    })

    return response
  }

  updateBuzzlUser = async ({
    id,
    customers,
    email,
    role,
    // displayName,
    firstName,
    lastName,
  }: BuzzlUserDTO & { id: string }): Promise<BuzzlUser> => {
    const assignedCustomers: Pick<Customer, 'id'>[] = customers.length > 0 ? parseAssignedUsers(customers) : []

    const { updateBuzzlUser: response } = await graphQLClient.request<{
      updateBuzzlUser: BuzzlUser
    }>(buzzlUserMutations.updateBuzzlUser, {
      where: {
        id,
      },
      data: {
        role,
        user: {
          update: {
            email,
            firstName,
            lastName,
            // displayName,
          },
        },
        assignedCustomers:
          role === buzzlRoles.operator
            ? {
                set: assignedCustomers,
              }
            : undefined,
      },
    })

    return response
  }
}

const buzzlUserService = new BuzzlUsersService()

export default buzzlUserService
